import { useEffect, useState } from "react";
import { TabReveal } from "./Animations";
import { RTabReveal } from "./Animations";

const Tab = ({show, children, customClass='test'}) => {
    const [showClass, setShowClass] = useState('');
    const moduleName = 'tab';
    const modifierClass = customClass ? `${moduleName}--${customClass}` : '';
    const remount = false;

    useEffect(() => {
        if ( show ) {
            setShowClass('show');
        } else {
            setShowClass('');
        }
    }, [show])

    const renderContent = () => {
        if ( remount ) {
            return (
                show && <TabReveal replay={ show }> { children } </TabReveal>
            )
        } 

        return (
            <TabReveal replay={ show }> { children } </TabReveal>
        );
    }

    return (
        <div className={`tab ${showClass} ${modifierClass}`}>
            {
                <TabReveal replay={ show }> { children } </TabReveal>
            }
        </div>
    )
}

export default Tab;